/* eslint-disable no-restricted-imports */
/* eslint-disable no-script-url,jsx-a11y/anchor-is-valid */
import React, { useMemo, useState, useCallback, useEffect } from 'react';
import { OverlayTrigger, Tooltip } from 'react-bootstrap';
import objectPath from 'object-path';
import { useHtmlClassService } from '../../_core/MetronicLayout';
import { UserProfileDropdown } from './dropdowns/UserProfileDropdown';
import { useRecoilValueLoadable, useSetRecoilState } from 'recoil';
import { useSnackbarWithStyles } from '../../../../app/components/notifications/SnackbarProviderWithStyles';
import { user, Role } from '../../../../recoil/atoms/user';
import { permissionsSelector } from '../../../../recoil/selectors/permissionsSelector';
import { resetBusinessID } from '../../../../common/changeBusinessID';
import { useSelector, useDispatch } from 'react-redux';
import { toggleSuperAdminDrawer } from '../../../../app/store/superAdminStatsSlice';
import makeStyles from '@mui/styles/makeStyles';
import { useHistory } from 'react-router-dom';
import { SwitchBusinessModal } from '../../../../app/components/modals/SwitchBusinessModal';
import SwitchIcon from '@mui/icons-material/SyncAlt';

const useStyles = makeStyles((theme) => ({
  symbolLabel: {
    backgroundColor: '#fff !important',
    border: '1px solid #ddd',
    '&.symbol-label svg': {
      height: '2rem !important',
      width: '2rem !important',
    },
  },
}));
const businessSnapshotEnabled = process.env.VITE_APP_BUSINESS_SNAPSHOT === '1';
export function QuickUserToggler() {
  const classes = useStyles();
  const history = useHistory();
  const { enqueueSnackbarWithStyles } = useSnackbarWithStyles();
  const uiService = useHtmlClassService();
  const dispatch = useDispatch();
  const [originalBusinessObject, setObi] = useState(
    localStorage.getItem('originalBusinessObject')
  );
  const updateUser = useSetRecoilState(user);
  const userAtom = useRecoilValueLoadable(user);
  const loginUser = userAtom.contents?.user ?? {};
  const fullName =
    userAtom.contents?.user?.fname + ' ' + userAtom.contents?.user?.lname;
  const superAdminStats = useSelector((state) => state.superAdminStats);
  const permissionsLoadable = useRecoilValueLoadable(permissionsSelector);
  const { shouldPopSuperAdminStats } = permissionsLoadable?.contents;

  const layoutProps = useMemo(() => {
    return {
      offcanvas:
        objectPath.get(uiService.config, 'extras.user.layout') === 'offcanvas',
    };
  }, [uiService]);

  const { role } = permissionsLoadable.contents;
  const [switchBusinessModal, handleSwitchBusinessModal] = useState(false);
  const handleSwitchModal = () => {
    handleSwitchBusinessModal(false);
    role === Role.SUPERADMIN &&
      !superAdminStats?.show &&
      dispatch(toggleSuperAdminDrawer(true));
    history.push(
      businessSnapshotEnabled
        ? '/call-reporting/business-snapshot'
        : '/call-reporting/agent-summary'
    );
  };
  const handleSwitch = useCallback(() => {
    const res = resetBusinessID();
    if (res.success) {
      updateUser(res.user);
      setObi(null);
      shouldPopSuperAdminStats &&
        !superAdminStats?.show &&
        dispatch(toggleSuperAdminDrawer(true));
    } else {
      enqueueSnackbarWithStyles({
        message: res.error,
        alertProps: {
          severity: 'error',
        },
      });
    }
  });

  useEffect(() => {
    const updated = localStorage.getItem('originalBusinessObject');
    if (updated) {
      setObi(updated);
    } else {
      setObi(null);
    }
  }, [localStorage.getItem('originalBusinessObject'), setObi]);

  return (
    <>
      {loginUser.role === 'superadmin' && (
        <div className="superStyle d-flex">
          {originalBusinessObject && (
            <div className="topbar-item" onClick={() => handleSwitch()}>
              <div className="btn btn-icon w-auto btn-clean d-flex align-items-center btn-lg px-2">
                <span className="text-muted font-weight-bold font-size-base d-none d-md-inline mr-1">
                  Viewing Business: {userAtom.contents?.businessid}
                </span>
                <span className="symbol symbol-35 symbol-light-danger">
                  <span className="symbol-label">
                    <span className="svg-icon svg-icon-md svg-icon-warning">
                      X
                    </span>
                  </span>
                </span>
              </div>
            </div>
          )}
          <OverlayTrigger
            placement="bottom"
            overlay={<Tooltip id="quick-user-tooltip">Switch business</Tooltip>}
          >
            <div
              data-pup="user-profile"
              className="topbar-item"
              onClick={() => handleSwitchBusinessModal(true)}
            >
              <div className="btn btn-icon w-auto btn-clean d-flex align-items-center btn-lg symbol symbol-35 symbol-light-warning">
                <span className="symbol-label">
                  <span className="svg-icon svg-icon-md svg-icon-warning">
                    <SwitchIcon />
                  </span>
                </span>
              </div>
            </div>
          </OverlayTrigger>
        </div>
      )}
      {layoutProps.offcanvas && (
        <OverlayTrigger
          placement="bottom"
          overlay={<Tooltip id="quick-user-tooltip">View user</Tooltip>}
        >
          <div className="topbar-item">
            <div
              className="btn btn-icon w-auto btn-clean d-flex align-items-center btn-lg px-2"
              id="kt_quick_user_toggle"
            >
              <>
                <span className="text-muted font-weight-bold font-size-base d-none d-md-inline mr-1">
                  {fullName}
                </span>
                <span className="text-dark-50 font-weight-bolder font-size-base d-none d-md-inline mr-3">
                  {}
                </span>
                <span className="symbol symbol-35 symbol-light-success">
                  <span className="symbol-label font-size-h5 font-weight-bold">
                    {fullName.substr(0, 1)}
                  </span>
                </span>
              </>
            </div>
          </div>
        </OverlayTrigger>
      )}

      {!layoutProps.offcanvas && <UserProfileDropdown />}
      <SwitchBusinessModal
        open={switchBusinessModal}
        handleSwitchBusinessModal={handleSwitchBusinessModal}
        handleSwitchModal={handleSwitchModal}
      />
    </>
  );
}
